import imgA from './assets/slider/a.jpg';
import imgB from './assets/slider/b.jpg';

export const sliderItems = [
  {
    id: 1,
    img: imgA,
    title: "",
    desc: "",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: imgB,
    title: "",
    desc: "",
    bg: "fcf1ed",
  }
];
